module.exports = __webpack_public_path__ + "static/media/bakvodvar_rodur_small.8ad5b049.png";